import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const PageDataContext = /*#__PURE__*/ React.createContext({
    appointmentDisplayType: 'single'
});
var PageDataProvider = (_param)=>{
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const { Provider  } = PageDataContext;
    return /*#__PURE__*/ React.createElement(Provider, {
        value: rest
    }, children);
};
const usePageData = ()=>React.useContext(PageDataContext)
;

export { PageDataProvider, usePageData };
//# sourceMappingURL=PageDataContext.js.map
